import { PropsWithChildren } from "react";
import { SimpleErrorNotification, SimpleLoader } from "shared/components/atoms";
import { EmptyState, EmptyStateProps } from "shared/components/root";

type PageContentProps = {
  loading?: boolean;
  showSimpleError?: boolean;
  throwAppError?: string;
  showEmptyStateWithProps?: EmptyStateProps;
} & PropsWithChildren;

export const PageContent = ({
  loading,
  showSimpleError,
  throwAppError,
  showEmptyStateWithProps,
  children,
}: PageContentProps) => {
  // If the error needs to throw a full application error, throw it
  if (throwAppError) {
    throw new Error(throwAppError);
  }

  return loading ? (
    <SimpleLoader />
  ) : showSimpleError ? (
    <SimpleErrorNotification />
  ) : showEmptyStateWithProps ? (
    <EmptyState {...showEmptyStateWithProps} />
  ) : (
    children
  );
};
